import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { PRIVACY_POLICY_URL, TERMS_URL } from '../../config';
interface ConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}

/**
 * Required express consent. Unchecked by default — the form cannot submit without it.
 * This is NOT a credit application and makes no promise of approval, rates, or terms.
 */
export function ConsentCheckbox({
  checked,
  onChange,
  error
}: ConsentCheckboxProps) {
  const {
    t
  } = useLanguage();
  return <div data-id="element-271" data-mp="xf4j9rd3niqx">
      <div className="flex items-start gap-3" data-id="element-272" data-mp="xc8k5zpimo0w">
        <input id="consent" name="consent" type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} aria-invalid={Boolean(error)} aria-describedby={error ? 'consent-error' : undefined} className="mt-1 h-5 w-5 shrink-0 accent-gold" data-id="element-273" data-mp="segulcccfdzv" />
        <label htmlFor="consent" className="text-sm leading-relaxed text-white/60" data-id="element-274" data-mp="392krhplnnvbi">
          {t('form.consent')}
        </label>
      </div>

      {(PRIVACY_POLICY_URL || TERMS_URL) && <p className="mt-2 pl-8 text-xs text-white/45" data-id="element-275" data-mp="7n2g6urzciy">
          {PRIVACY_POLICY_URL ? <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className="underline hover:text-gold" data-id="element-276" data-mp="3idhu6cwd2bxi">
              {t('form.privacy')}
            </a> : null}
          {PRIVACY_POLICY_URL && TERMS_URL ? <span aria-hidden="true" data-id="element-277" data-mp="3dfq29ivpuptb"> · </span> : null}
          {TERMS_URL ? <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="underline hover:text-gold" data-id="element-278" data-mp="2yr3eqtvxqrr0">
              {t('form.terms')}
            </a> : null}
        </p>}

      {error ? <p id="consent-error" role="alert" className="mt-2 pl-8 text-sm text-kred" data-id="element-279" data-mp="2uoym9yh8415y">
          {error}
        </p> : null}
    </div>;
}